module.exports = __webpack_public_path__ + "static/media/frontDay.b2edb31d.jpeg";